/**
 * Copyright 2022 Design Barn Inc.
 */

import classNames from 'classnames';
import React from 'react';

interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

export default function Spinner(props: SpinnerProps): React.ReactElement {
  const { className = '', size = 'md' } = props;

  const classes = classNames(
    'border-2 border-solid rounded-full animate-spin inline-block border-l-white border-teal-300',
    {
      'w-6 h-6': size === 'md',
      'w-8 h-8': size === 'lg',
      'w-10 h-10': size === 'xl',
      'w-12 h-12': size === 'xxl',
      'w-4 h-4': size === 'sm',
    },
    className,
  );

  return (
    <div className={classes} role="status">
      <span className="hidden">Loading...</span>
    </div>
  );
}
